import { render, staticRenderFns } from "./SegmentData.vue?vue&type=template&id=3f0ca2cd&scoped=true&"
import script from "./SegmentData.vue?vue&type=script&lang=js&"
export * from "./SegmentData.vue?vue&type=script&lang=js&"
import style0 from "./SegmentData.vue?vue&type=style&index=0&id=3f0ca2cd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0ca2cd",
  null
  
)

export default component.exports